<!doctype html>
<html lang="en">

<head>

  <meta charset="utf-8"/>
  <title>Login | CognitoX</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta content="CognitoX" name="description"/>
  <meta content="CognitoX" name="author"/>
  <!-- App favicon -->
  <link rel="shortcut icon" href="/src/assets/apanel/images/logos/logo.svg">

  <!-- Bootstrap Css -->
  <link href="/src/assets/apanel/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
  <!-- Icons Css -->
  <link href="/src/assets/apanel/css/icons.min.css" rel="stylesheet" type="text/css"/>
  <!-- App Css-->
  <link href="/src/assets/apanel/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
  <!-- App js -->
  <script src="/src/assets/apanel/js/plugin.js"></script>

</head>

<body>
<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-success-subtle">
            <div class="row">
              <div class="col-7">
                <div class="text-success-emphasis p-4">
                  <h5 class="text-success-emphasis" i18n="@@msg.WelcomeToCognito">Welcome to Cognito Software!</h5>
                  <p i18n="@@msg.EnterInformation">Please help us with few information.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="/src/assets/apanel/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="auth-logo">
              <a href="javascript:void(0);" class="auth-logo-light">
                <div class="avatar-md profile-user-wid mb-4">
                      <span class="avatar-title rounded-circle bg-light">
                          <img src="/src/assets/apanel/images/logos/logo.svg" alt=""
                               class="rounded-circle" height="48">
                      </span>
                </div>
              </a>

              <a href="javascript:void(0);" class="auth-logo-dark">
                <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-light">
                        <img src="/src/assets/apanel/images/logos/logo.svg" alt=""
                             class="rounded-circle"
                             height="48">
                    </span>
                </div>
              </a>
            </div>
            <div class="p-2">

              <div *ngIf="message" class="mb-5">
                <em class="bg-success-subtle bg-success py-2 px-2 mb-5">
                  {{ message }}
                </em>

              </div>

              <form class="form-horizontal" [formGroup]="preRegForm" (ngSubmit)="preRegister()">

                <div class="mb-3">
                  <label for="name" class="form-label" i18n="@@label.Name">Name</label>&nbsp;<em class="error">*</em>
                  <input type="text" class="form-control" id="name" formControlName="name"
                         placeholder="{{translations['Enter Name']}}">
                  <em class="text-danger">
                    {{ errMsg(preRegForm, 'name', 'required', translations['NameValidation']) }}
                  </em>
                </div>
                <div class="mb-3">
                  <label for="phone" class="form-label" i18n="@@label.Phone">Phone</label>&nbsp;<em class="error">*</em>
                  <input type="text" class="form-control" id="phone" formControlName="phone"
                         placeholder="{{translations['Enter Phone']}}">
                  <em class="text-danger">
                    {{ errMsg(preRegForm, 'phone', 'required', translations['PhoneValidation']) }}
                  </em>
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label" i18n="@@label.Email">Email</label>
                  <input type="email" class="form-control" id="email" formControlName="email"
                         placeholder="{{translations['Enter Email']}}">
                </div>
                <div class="mb-3">
                  <label for="package_type" class="form-label" i18n="@@label.PackageType">Package Type</label>&nbsp;<em class="error">*</em>
                  <select class="form-select" id="package_type" formControlName="package_type">
                    <option value="Atomic" i18n="@@label.Atomic">Atomic</option>
                    <option value="Planetary" i18n="@@label.Planetary">Planetary</option>
                    <option value="Cosmic" i18n="@@label.Cosmic">Cosmic</option>
                  </select>
                  <em class="text-danger">
                    {{ errMsg(preRegForm, 'package_type', 'required', 'Package Type is required!') }}
                  </em>
                </div>
                <div class="mb-3">
                  <label for="business_type" class="form-label" i18n="@@label.BusinessType">Business Type</label>&nbsp;<em class="error">*</em>
                  <input type="text" class="form-control" id="business_type" formControlName="business_type"
                         placeholder="{{translations['BusinessType']}}">
                  <em class="text-danger">
                    {{ errMsg(preRegForm, 'business_type', 'required', translations['BTValidation']) }}
                  </em>
                </div>

                <div class="mt-3 d-grid">
                  <button class="btn btn-success waves-effect waves-light" i18n="@@label.Submit"
                          type="submit" [disabled]="!preRegForm.valid">Submit
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
<!--        <div class="mt-5 text-center">-->

<!--          <div>-->
<!--            <p>Don't have an account ? <a href="javascript::void()" routerLink="/sign-up"-->
<!--                                          class="fw-medium text-primary"> Signup now </a></p>-->
<!--            <p>©-->
<!--              <script>document.write(new Date().getFullYear())</script>-->
<!--              servicito-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->

      </div>
    </div>
  </div>
</div>
<!-- end account-pages -->

<!-- JAVASCRIPT -->
<script src="/src/assets/apanel/libs/jquery/jquery.min.js"></script>
<script src="/src/assets/apanel/libs/bootstrap/js/bootstrap.bundle.min.js"></script>
<script src="/src/assets/apanel/libs/metismenu/metisMenu.min.js"></script>
<script src="/src/assets/apanel/libs/simplebar/simplebar.min.js"></script>
<script src="/src/assets/apanel/libs/node-waves/waves.min.js"></script>

<!-- App js -->
<script src="/src/assets/apanel/js/app.js"></script>
</body>
</html>





